import React from 'react';

// Types
import { ReviewTemplateType } from 'Shared/types/ReviewTemplates.type';

// Components
import ReviewTemplateListItem from './ReviewTemplateListItem';

// Styles
import './ReviewTemplateList.scss';

type Props = {
  reviewTemplates: ReviewTemplateType[];
  handleChooseTemplate?: Function;
};

const ReviewTemplateList = ({ reviewTemplates, handleChooseTemplate }: Props) => {
  const baseClassName = 'ReviewTemplateList';
  return (
    <div className={baseClassName}>
      {reviewTemplates.map(template => (
        <ReviewTemplateListItem key={template.slug} template={template} handleChooseTemplate={handleChooseTemplate} />
      ))}
    </div>
  );
};

export default ReviewTemplateList;
